module.exports = __webpack_public_path__ + "static/media/next.ba614657.png";